var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleeDashboardEndIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 53.134,
    viewBox: "0 0 50 53.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5894",
    "data-name": "\\uD328\\uC2A4 5894",
    d: "M23.346,27.061V4.543a3.543,3.543,0,1,1,7.087,0V27.061a3.543,3.543,0,0,1-7.087,0Zm18-18.319a3.544,3.544,0,1,0-4.11,5.776,17.912,17.912,0,1,1-20.693,0,3.544,3.544,0,0,0-4.11-5.776,25,25,0,1,0,28.914,0Z",
    transform: "translate(-1.889 -1)",
    fill: "rgba(255,255,255,0.17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleeDashboardEndIcon);
export default __webpack_public_path__ + "static/media/fleeDashboardEndIcon.14797486d8b6179a1be140a722a33352.svg";
export { ForwardRef as ReactComponent };